import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadStaticDataProductSolutions = createAction(
  '[StaticData] Load ProductSolutions',
  props<{ request: { businessId: string, product: string }, noLoader: boolean}>(),
  );

export const loadStaticDataProductSolutionsSuccess = createAction(
  '[StaticData] Load ProductSolutions Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadStaticDataProductSolutionsFailure = createAction(
  '[StaticData] Load ProductSolutions Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
